import { BodyTextMedium, HeadingText50 } from '@modernhealth/vital-components';
import React from 'react';
import styled from '@emotion/styled';

import { ReactComponent as BannerLeft } from '../assets/international-banner-left.svg';
import { ReactComponent as BannerRight } from '../assets/international-banner-right.svg';

interface CircleCenteredBannerProps {
    header: string;
    description: string;
}

export const CircleCenteredBanner: React.FC<CircleCenteredBannerProps> = ({
    header,
    description,
}) => {
    return (
        <Container>
            <HeadingText50>{header}</HeadingText50>
            <BodyTextMedium
                css={{
                    zIndex: 10,
                }}
            >
                {description}
            </BodyTextMedium>
            <BannerContainer>
                <BannerLeft width={180} preserveAspectRatio="xMinYMax" />
                <BannerBottomGradient />
                <BannerRight width={180} preserveAspectRatio="xMinYMax" />
            </BannerContainer>
        </Container>
    );
};

const BannerBottomGradient = styled.div({
    width: '100%',
    height: '3rem',
    alignSelf: 'flex-end',
    backgroundImage: 'linear-gradient(180deg, #FFFFFF 65.93%, #EFFAFF 124.54%);',
});

const BannerContainer = styled.div({
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    zIndex: 9,
    marginTop: '-1rem',
});

const Container = styled.div({
    display: 'flex',
    alignItems: 'center',
    justifyItems: 'center',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    width: '100%',
});
